// Stripe Payment Service
// HTTP-based integration to the onRequest Cloud Function `processPayment`.
// Mirrors the BASE_URL logic used in other API clients.

// Production Cloud Functions URL (Firebase Functions v2)
// Format: https://{region}-{project-id}.cloudfunctions.net/{function-name}
const PRODUCTION_BASE_URL = 'https://us-central1-payattable-c0e8c.cloudfunctions.net';

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? PRODUCTION_BASE_URL;

export class StripePaymentService {
  static async processPurchase(data: any): Promise<any> {
    const url = `${BASE_URL}/processPayment`;

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({} as any));
      const msg = (err && (err.errorDescription || err.message || err.error)) || 'Error al procesar el pago';
      throw new Error(msg);
    }

    return res.json();
  }
}

